import { Flex, Icon, Text } from "@huub-web/ui";
import type { FC } from "react";

export type LoaderStepProps = {
  label: string;
  status: "pending" | "in-progress" | "completed" | "waiting" | "error";
};

export const LoaderStep: FC<LoaderStepProps> = ({ label, status }) => {
  const icon = (() => {
    if (status === "pending") {
      return "chevronRight";
    }
    if (status === "in-progress") {
      return "loading";
    }
    if (status === "completed") {
      return "check";
    }
    if (status === "waiting") {
      return "waiting";
    }
    if (status === "error") {
      return "close";
    }
    return "check";
  })();

  return (
    <Flex as="li" gap="xs" align="center">
      <Icon
        icon={icon}
        animation={status === "in-progress" ? "rotation" : undefined}
        color={
          status === "pending"
            ? "currentColor50"
            : status === "error"
              ? "error"
              : undefined
        }
        size="s"
      />
      <Text
        grow
        color={
          status === "pending"
            ? "currentColor50"
            : status === "error"
              ? "error"
              : undefined
        }
      >
        {label}
      </Text>
    </Flex>
  );
};
